/* jshint esversion: 6, -W097, -W040 */
/* globals module */
'use strict';

/**
 * Helper directive to fire callbacks when an element first become visible
 *
 * @module enervee_utils.common
 */
function onScrollIntoViewConfig() {
    return {
        restrict: 'A',
        controller: onScrollIntoViewController,
        link: onScrollIntoViewLink,
    };
}

onScrollIntoViewController.$inject = ['$window', '$timeout', 'UtilService'];
function onScrollIntoViewController($window, $timeout, UtilService) {
    var vm = this;
    vm.timeout = $timeout;
    vm.window = $window;
    vm.deregisterScrollListener = deregisterScrollListener;

    angular.element($window).on('scroll', onWindowScroll);

    /**
     * Removes the "scroll" event listener from the window.
     */
    function deregisterScrollListener() {
        angular.element($window).off('scroll', onWindowScroll);
    }

    /**
     * Runs each time the window scrolls, debounced to every 10 milliseconds.
     * Checks to see if the callback should be run.
     */
    function onWindowScroll() {
        UtilService.debounce('scroll-' + vm.scopeId, function () {
            vm.checkIfCallbackShouldBeRun();
        }, 10);
    }
}

function onScrollIntoViewLink(scope, elem, attrs, ctrl) {
    ctrl.checkIfCallbackShouldBeRun = checkIfCallbackShouldBeRun;
    ctrl.scopeId = scope.$id;

    var attrsToWatch = ['ngIf', 'ngHide', 'ngShow', 'ngClass'];
    var watchedAttributesUnregisters = [];
    var callbackFired = false;

    ctrl.timeout(function () {
        init();
    }, 150);

    scope.$on('$destroy', ctrl.deregisterScrollListener);
    if (!attrs.onScrollIntoView) {
        ctrl.deregisterScrollListener();
    }

    /**
     * Checks to see if the callback should execute immediately.
     * If it doesn't, sets up watchers and listeners for display-changing attributes and scroll
     * events to keep checking to see if the callback should execute.
     */
    function init() {
        checkIfCallbackShouldBeRun();
        if (callbackFired) {
            return;
        }
        var watchEveryDigest = scope.$watch(function () {
            checkIfCallbackShouldBeRun();
        });
        watchedAttributesUnregisters.push(watchEveryDigest);
        attrsToWatch.forEach(function (attrName) {
            var attr = attrs[attrName];
            if (attr) {
                var attrWatch = scope.$watch(attr, function () {
                    ctrl.timeout(function () {
                        checkIfCallbackShouldBeRun();
                    }, 50);
                });
                watchedAttributesUnregisters.push(attrWatch);
            }
        });
    }

    /**
     * Checks to see if the element's "display" css rule is set to anything other than "none".
     * If it is, then it returns true. Otherwise, it returns false.
     *
     * @return {Boolean}
     */
    function elemIsVisible() {
        return elem.css('display') !== 'none';
    }

    /**
     * Checks if the element is in view by comparing its bounding box coordinates to the
     * window height. If either edge is within the window's boundaries, it returns true.
     * Otherwise, it returns false.
     *
     * @return {Boolean}
     */
    function elemIsInScrollView() {
        var boundingBox = elem[0].getBoundingClientRect();
        var topEdgeVisible = boundingBox.top > 0 && boundingBox.top < ctrl.window.innerHeight;
        var bottomEdgeVisible = boundingBox.bottom > 0 && boundingBox.bottom < ctrl.window.innerHeight;
        return topEdgeVisible || bottomEdgeVisible;
    }

    /**
     * Checks if the elem is displayed and has been scrolled into view. If both are true,
     * it attempts to fire the callback.
     */
    function checkIfCallbackShouldBeRun() {
        if (callbackFired) {
            return;
        }
        if (elemIsVisible() && elemIsInScrollView()) {
            fireCallback();
        }
    }

    /**
     * Executes the callback once, if it has not already been executed.
     */
    function fireCallback() {
        if (!callbackFired) {
            callbackFired = true;
            callback();
            watchedAttributesUnregisters.forEach(function (unregister) {
                unregister();
            });
        }
    }

    /**
     * Evaluates the callback in the directive's template, executing it
     */
    function callback() {
        if (attrs.onScrollIntoView) {
            scope.$eval(attrs.onScrollIntoView, scope);
        }
    }
}

module.exports = onScrollIntoViewConfig;